import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
	InvoiceNumberingPayload,
	InvoiceNumberingRules
} from '@models/settings.model';
import { Observable } from 'rxjs';
import { ServerDataResponse } from '@models/models';

@Injectable()
export class InvoicePaymentsDataService {
	constructor(private http: HttpClient) {}

	getInvoiceNumberingRules(): Observable<
		ServerDataResponse<InvoiceNumberingRules>
	> {
		const url = '/api/user/v1/invoice/numbering/rule';
		return this.http.get(url) as Observable<
			ServerDataResponse<InvoiceNumberingRules>
		>;
	}

	saveInvoiceNumberingRules(
		data: InvoiceNumberingPayload
	): Observable<ServerDataResponse<void>> {
		const url = '/api/user/v1/invoice/numbering/rule';
		return this.http.post(url, data) as Observable<ServerDataResponse<void>>;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/services/settings/invoice-payments/invoice-payments.data.ts